import { hideModal } from '@shared/ui/modal.util';

class BankModalController {
  hideBankModal() {
    hideModal('bankModal');
  }
}

export default BankModalController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/bank.modal.controller.js